var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homePage"},[_c('div',{staticClass:"homePage-top"},[_c('totel',{staticClass:"totel",attrs:{"asset":""}})],1),_vm._v(" "),_c('echart',{staticClass:"homePage-center"}),_vm._v(" "),_c('div',{staticClass:"homePage-bottom"},[_c('systemnews')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2d81f40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HomePage.vue
// module id = null
// module chunks = 